/**
 * ag-grid-facets
 */

import $ from 'jquery';
import { render, Fragment } from 'preact';
import { useState } from 'preact/hooks';
// Module styles
import './_ag-grid-facets.scss';

// Module template
import './_ag-grid-facets.twig';

import init from './facets';
import FacetsGroup from './facetsGroup';

const Facets = (props) => {
  const [displayFilters, setDisplayFilters] = useState(false);
  const [expandFacetsLinks, setExpandFacetsLinks] = useState(1);
  const [isFacetsGroupClickEvent, setFacetsGroupClickEvent] = useState(false);
  const [scrollPos, setScrollPos] = useState(0);

  const api = init({
    agGridInstanceId: props.agGridInstanceId,
    totalResults: 0,
    totalItems: 0,
    exclude: props.exclude,
    facetLabels: {},
    facets: {},
    measurementSystem: props.measurementSystem,
    sorting: props.sorting,
    images: props.images,
    imagesdescriptions: props.imagesdescriptions,
    equivalencies: props.equivalencies,
  });

  const openMobileFilters = () => {
    setScrollPos(window.scrollY);
    setDisplayFilters(!displayFilters);
    $('body').toggleClass('ag-grid-facets--expanded');
    $('#backtotop').addClass('hide-backtotop');
  };

  const closeMobileFilters = () => {
    $('body').toggleClass('ag-grid-facets--expanded');
    window.scrollTo({
      top: scrollPos,
    });
    setDisplayFilters(!displayFilters);
    $('#backtotop').removeClass('hide-backtotop');
  };

  const toggleExpandCollapse = (event) => {
    setExpandFacetsLinks(event.target.value);
    setFacetsGroupClickEvent(true);
  };

  return (
    api.getTotalItems() > 1 &&
    api.getFacets().length > 0 && (
      <Fragment>
        <div
          onClick={openMobileFilters}
          className={'ag-grid-facets__mobile-filters-open-btn mobile-element'}
          tab
        >
          {Drupal.t('Filter By')}
        </div>
        <div
          className={`ag-grid-facets__filters ${
            displayFilters ? 'display' : ''
          }`}
        >
          <div class={`ag-grid-facets__filters-header`}>
            <h2 class={`ag-grid-facets__label`}>
              <span className={`mobile-element`}>{Drupal.t('Select')} </span>
              {Drupal.t('Filters')}
            </h2>
            <button
              className={
                'ag-grid-facets__mobile-filters-close-btn mobile-element'
              }
              onClick={closeMobileFilters}
            >
              {'\u00d7'}
            </button>
          </div>
          <div className={`ag-grid-facets__clear-filters-header`}>
            <div className={`facets-header__label`}>
              {Drupal.t('Filter By')}
            </div>
            <span
              className={
                api.getFiltersCount() === 0
                  ? `visually-hidden ag-grid-facets__clear-filters`
                  : `ag-grid-facets__clear-filters`
              }
              onClick={() => {
                api.clearFacets();
              }}
            >
              {Drupal.t('Clear filters')}
            </span>
          </div>
          <div
            className={`ag-grid-facets-action expand-collapse`}
            data-expanded={expandFacetsLinks}
          >
            <li className={`expand`} value={0} onClick={toggleExpandCollapse}>
              {Drupal.t('Expand all')}
            </li>
            <li className={`collapse`} value={1} onClick={toggleExpandCollapse}>
              {Drupal.t('Collapse all')}
            </li>
          </div>
          <div className={`ag-grid-facets__filters-count`}>
            {api.getFiltersCount() === 1
              ? Drupal.t('Filter applied')
              : Drupal.t('Filters applied')}
            :<strong>{api.getFiltersCount()}</strong>
          </div>
          <ul>
            {api.getFacets().map((facet) => {
              const isClosed = isFacetsGroupClickEvent
                ? expandFacetsLinks
                : !facet.active;

              const values = Object.values(facet.values).map((facetValue) => {
                // Skip this check for BABA compliant facet.
                if (
                  facetValue.facetId !== 'baba' &&
                  !api.isAvailableFacet(facet, facetValue)
                ) {
                  return null;
                }
                return (
                  <li
                    className={`ag-grid-facets__group-value ${
                      facetValue.active ? 'active' : ''
                    }`}
                  >
                    <input
                      id={facetValue.id}
                      type="checkbox"
                      checked={facetValue.active}
                      onChange={() => {
                        api.facetValueToggleStatus(facetValue);
                      }}
                    />
                    <label for={facetValue.id}>
                      {facetValue.label}
                      {facetValue.count > 0 ? ` (${facetValue.count})` : ''}
                    </label>
                  </li>
                );
              });

              if (
                values.filter((el) => el).length === 0 ||
                api.isVisibleInMeasurementSystem(facet) === false
              ) {
                return null;
              }

              return (
                <FacetsGroup values={values} facet={facet} closed={isClosed} />
              );
            })}
          </ul>
        </div>
        <div className={`ag-grid-facets__top`}>
          <div className={`ag-grid-facets__counter OneLinkNoTx`}>
            <strong>{api.getTotalResults()}</strong> {Drupal.t('parts found.')}
          </div>
          <div className={`ag-grid-facets__pills pills`}>
            <ul>
              {api.getFacets().map((facet) => {
                const values = Object.values(facet.values).map((facetValue) => {
                  if (!facetValue.active) {
                    return null;
                  }
                  return (
                    <li className={`ag-grid-facet-group-value pill`}>
                      <input
                        id={facetValue.id}
                        type="checkbox"
                        checked={facetValue.active}
                        onChange={() => {
                          api.facetValueToggleStatus(facetValue);
                        }}
                      />
                      <label for={facetValue.id}>
                        {facet.label}: {facetValue.label}
                      </label>
                    </li>
                  );
                });
                if (
                  values.filter((el) => el).length === 0 ||
                  api.isVisibleInMeasurementSystem(facet) === false
                ) {
                  return null;
                }

                return values;
              })}
            </ul>
          </div>
          <div className={`ag-grid-facets__images`}>
            <ul>
              {api.getFacetsImages().map((facet) => {
                const values = Object.values(facet.values).map((facetValue) => {
                  return (
                    <li className={`ag-grid-facet-group-value image`}>
                      <input
                        id={facetValue.id}
                        type="checkbox"
                        checked={facetValue.active}
                        onChange={() => {
                          api.facetValueToggleStatus(facetValue);
                        }}
                      />
                      <label htmlFor={facetValue.id}>
                        <div>
                          <div className={`facet-label`}>
                            {facetValue.label}
                          </div>
                          <img
                            data-src={facetValue.image}
                            class="lazy-facet-image"
                          />
                          <div className={`facet-desc`}>
                            {facetValue.description}
                          </div>
                        </div>
                      </label>
                    </li>
                  );
                });
                if (values.filter((el) => el).length === 0) {
                  return null;
                }

                return (
                  <li>
                    {!facet.active && (
                      <div className={`title`}>{facet.label}</div>
                    )}
                    <ul className={`ag-grid-facets__detail`}> {values} </ul>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </Fragment>
    )
  );
};

export const name = 'ag-grid-facets';

export const defaults = {
  dummyClass: 'js-ag-grid-facets-exists',
};

/* eslint-disable */
/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, settings) {
  const $parent = $('.ag-grid-facets');
  if ($parent.data('enabled') === 1) {
    const agGridInstanceId = $parent.data('ag-grid-instance-id');
    const exclude = $parent.data('exclude') || [];
    const sorting = $parent.data('sorting') || {};
    const images = $parent.data('images') || {};
    const imagesdescriptions = $parent.data('imagesdescriptions') || {};
    const equivalencies =
      ($parent.hasClass('OneLinkNoTx')
        ? $parent.data('raw-equivalencies')
        : $parent.data('equivalencies')) || {};
    const measurementSystem = 'imperial';
    render(
      <Facets
        agGridInstanceId={agGridInstanceId}
        exclude={exclude}
        sorting={sorting}
        measurementSystem={measurementSystem}
        images={images}
        imagesdescriptions={imagesdescriptions}
        equivalencies={equivalencies}
      />,
      $parent.get(0)
    );
  } else {
    $parent.remove();
  }

  // Disable scroll on resize on mobile if filters are open
  function disableScroll() {
    const lgBreakpoint = '920';

    if (window.innerWidth < lgBreakpoint) {
      if ($('.ag-grid-facets__filters.display').length > 0) {
        $('body').addClass('ag-grid-facets--expanded');
      }
    } else {
      $('body').removeClass('ag-grid-facets--expanded');
    }
  }

  let debounceTimer;

  function debounceDisableScroll() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(disableScroll, 250);
  }

  $(window).on('resize', debounceDisableScroll);

  window.addEventListener(
    'DOMContentLoaded',
    function handleDOMContentLoaded() {
      var checkImagesInterval;

      function checkImagesFormed() {
        const lazyImages = document.querySelectorAll('.lazy-facet-image');
        if (lazyImages.length > 0) {
          clearInterval(checkImagesInterval);
          applyLazyLoading();
        }
      }

      function applyLazyLoading() {
        const lazyLoadInstance = new LazyLoad({
          elements_selector: '.lazy-facet-image',
          threshold: 0,
        });
      }

      checkImagesInterval = setInterval(checkImagesFormed, 1000);
    }
  );
}

export default enable;
/* eslint-enable */

enable($('.ag-grid-facets'), {});
